import React, { useState } from "react";
import { Calendar } from "lucide-react";

const getTodayDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const ReturnAssetDrawer = ({
  asset,
  onClose,
  onConfirm,
  errorMessage = "",
}) => {
  const today = getTodayDateString();
  const [formData, setFormData] = useState({
    returnDate: asset?.returnDate ? String(asset.returnDate).split("T")[0] : "",
    status: "Returned",
  });

  const profilePicture =
    asset?.resource?.profilePicture || asset?.resource?.image || null;
  const resourceName = asset?.resource?.name || "Unassigned";

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    onConfirm?.({
      ...asset,
      ...formData,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/20">
      {/* Drawer */}
      <div className="w-full max-w-[430px] h-full bg-white p-6 overflow-y-auto">
        {/* Header */}
        <h2 className="text-[28px] font-semibold">Mark as Returned</h2>

        <p className="text-sm text-gray-400 mt-1">
          Update the return date and status for this asset
        </p>

        {/* User Card */}
        <div className="mt-6 bg-[#F5F7FB] rounded-lg p-4 flex items-center gap-3">
          {profilePicture ? (
            <img
              src={profilePicture}
              alt=""
              className="w-14 h-14 rounded-full object-cover"
            />
          ) : (
            <div className="w-14 h-14 rounded-full bg-indigo-100 flex items-center justify-center text-lg font-bold text-blue-600">
              {resourceName[0]}
            </div>
          )}

          <div>
            <h3 className="font-medium">{resourceName}</h3>

            <p className="text-xs text-gray-400">
              {asset?.resource?.email || "-"}
            </p>

            <p className="text-xs text-gray-400">{asset?.empId || "-"}</p>
          </div>
        </div>

        {/* Asset Details */}
        <h4 className="mt-12 text-sm font-semibold">ASSET DETAILS</h4>

        <hr className="my-3" />

        {/* Asset Type */}
        <div className="mb-5">
          <label className="text-sm font-medium">Asset Type</label>

          <input
            value={asset?.category || asset?.type || ""}
            readOnly
            className="
              mt-2 w-full h-11
              border rounded-lg px-3
              text-sm bg-white
              outline-none
            "
          />
        </div>

        {/* Return Date */}
        <div className="mb-5">
          <label className="text-sm font-medium">Return Date</label>

          <div className="relative mt-2">
            <Calendar
              size={16}
              className="
                absolute left-3 top-1/2
                -translate-y-1/2
                text-[#4C5CE7]
              "
            />

          <input
    type="date"
    name="returnDate"
    value={formData.returnDate}
    onChange={handleChange}
    max={today}
    className="
      w-full h-11
      border rounded-lg
      pl-10 pr-3
      text-sm outline-none
    "
  />
          </div>
        </div>

        {/* Update Status */}
        <div className="mb-5">
          <label className="text-sm font-medium">Update Status</label>

          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="
              mt-2 w-full h-11
              border rounded-lg
              px-3 text-sm
              outline-none
            "
          >
            <option>Returned</option>
            <option>Active</option>
          </select>
        </div>

        {errorMessage ? (
          <p className="mb-4 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-600">
            {errorMessage}
          </p>
        ) : null}

        {/* Footer Buttons */}
        <div className="flex gap-3 mt-6">
          <button
            onClick={onClose}
            className="
              flex-1 h-11
              border border-[#4C5CE7]
              rounded-lg
              text-[#4C5CE7]
            "
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="
              flex-1 h-11
              bg-[#4C5CE7]
              rounded-lg
              text-white
            "
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReturnAssetDrawer;
